/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';

const ModalRegister = () => {
  const [form, setForm] = useState({
    is_company: 1,
    full_name: '',
  });
  const [isSuccess, setIsSuccess] = useState(null);
  const [formError, setFormError] = useState({});
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);

  const handlerForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
  };

  const checkInputs = (value, rules, id, name) => {
    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i];
      const [min, length] = rule.split(':');
      if (
        rule === 'required' &&
        (value === null || value === undefined || value.trim() === '')
      ) {
        formError[id] = {
          isError: 1,
          message: `${name} không được bỏ trống.`,
        };
        setFormError({ ...formError });
        return;
      }
      if (rule === 'email') {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9]+([a-zA-Z\-0-9])?[a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(value)) {
          formError[id] = {
            isError: 1,
            message: `Email không hợp lệ.`,
          };
          setFormError({ ...formError });
          return;
        }
      }
      if (min === 'min' && value.length < Math.abs(length)) {
        formError[id] = {
          isError: 1,
          message: `${name} quá ngắn`,
        };
        setFormError({ ...formError });
        return;
      }
    }
    formError[id] = {
      isError: 2,
    };
    setFormError({ ...formError });
    return;
  };

  useEffect(() => {
    const errorLists = Object.values(formError);
    if (errorLists.length === 3 || errorLists.length === 4) {
      for (let i = 0; i < errorLists.length; i++) {
        const { isError } = errorLists[i];
        if (isError === 1) {
          setIsDisabledBtn(false);
          break;
        }
        setIsDisabledBtn(true);
      }
    }
  }, [formError]);

  const handlerChooseOption = (value) => {
    setForm({ is_company: value, full_name: '' });
    setFormError({});
    setIsDisabledBtn(false);
  };

  const handlerFormRegister = (e) => {
    e.preventDefault();
    axios
      .post('/api/v1/register', { ...form })
      .then(({ data }) => {
        if (data.success) {
          setForm({ is_company: form.is_company, full_name: '' });
          setFormError({});
          setIsDisabledBtn(false);
          $('#modal-register')
            .removeClass('show')
            .css('display', 'none')
            .attr('aria-hidden', true);
          $('#modal-success').addClass('show').css('display', 'block');
        } else {
          setIsSuccess(false);
        }
      })
      .catch(() => {
        setIsSuccess(false);
      });
  };

  return (
    <>
      <div className='modal fade modal-register' id='modal-register'>
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <h5>Chỉ vài thao tác</h5>
            <h2>Bạn đã có thể tham gia SMEs.</h2>
            <ul className='register_select nav flex'>
              <li>
                <a
                  href='#personal'
                  data-toggle='tab'
                  title=''
                  onClick={() => {
                    handlerChooseOption(0);
                  }}
                >
                  <i className='icon'></i> Cá nhân
                </a>
              </li>
              <li>
                <a
                  href='#enterprise'
                  data-toggle='tab'
                  className='active'
                  title=''
                  onClick={() => {
                    handlerChooseOption(1);
                  }}
                >
                  <i className='icon'></i> Doanh nghiệp
                </a>
              </li>
            </ul>
            <div className='tab-content'>
              <div id='personal' className='tab-pane fade'>
                <form
                  onSubmit={(e) => {
                    handlerFormRegister(e);
                  }}
                >
                  <div className='form-group'>
                    <label>Họ và tên</label>
                    <input
                      type='text'
                      name='fullname'
                      placeholder=''
                      value={form.full_name || ''}
                      style={
                        formError.full_name?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      onChange={(e) => {
                        handlerForm(e.target.value, 'full_name');
                        checkInputs(
                          e.target.value,
                          ['required'],
                          'full_name',
                          'Họ và tên'
                        );
                      }}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required'],
                          'full_name',
                          'Họ và tên'
                        );
                      }}
                    />
                    {formError.full_name &&
                    formError.full_name?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.full_name?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label>Email</label>
                    <input
                      type='email'
                      name='email'
                      placeholder=''
                      value={form.email || ''}
                      style={
                        formError.email?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      onChange={(e) => {
                        handlerForm(e.target.value, 'email');
                        checkInputs(
                          e.target.value,
                          ['required', 'email'],
                          'email',
                          'Email'
                        );
                      }}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required', 'email'],
                          'email',
                          'Email'
                        );
                      }}
                    />
                    {formError.email && formError.email?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.email?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label>Số điện thoại</label>
                    <input
                      type='phone_number'
                      name='phone_number'
                      placeholder=''
                      value={form.phone_number || ''}
                      style={
                        formError.phone_number?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      onChange={(e) => {
                        handlerForm(e.target.value, 'phone_number');
                        checkInputs(
                          e.target.value,
                          ['required', 'phone_number'],
                          'phone_number',
                          'Số điện thoại'
                        );
                      }}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required', 'phone_number'],
                          'phone_number',
                          'Số điện thoại'
                        );
                      }}
                    />
                    {formError.phone_number &&
                    formError.phone_number?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.phone_number?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label>Mật khẩu</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        id='password-field1'
                        type='password'
                        name='password'
                        placeholder=''
                        required
                        style={
                          formError.password?.isError === 1
                            ? {
                                borderColor: '#ff3333',
                              }
                            : {}
                        }
                        value={form.password || ''}
                        onChange={(e) => {
                          handlerForm(e.target.value, 'password');
                          checkInputs(
                            e.target.value,
                            ['required', 'min:6'],
                            'password',
                            'Mật khẩu'
                          );
                        }}
                        onBlur={(e) => {
                          checkInputs(
                            e.target.value,
                            ['required', 'min:6'],
                            'password',
                            'Mật khẩu'
                          );
                        }}
                      />
                      <span
                        toggle='#password-field1'
                        className='toggle-password'
                      ></span>
                    </div>
                    {formError.password && formError.password?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.password?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <button
                    type='submit'
                    className='btn_submit flex-center'
                    style={
                      !isDisabledBtn
                        ? { background: ' #BBBBBB', color: '#ffffff' }
                        : {}
                    }
                  >
                    Tạo tài khoản
                  </button>
                  <span className='text-danger'>
                    {isSuccess === false
                      ? '*Đăng kí không thành công, vui lòng kiểm tra lại thông tin đăng ký.'
                      : ''}
                  </span>
                </form>
                <div className='signup'>
                  Đã có tài khoản{' '}
                  <a
                    data-dismiss='modal'
                    data-toggle='modal'
                    data-target='#modal-login'
                  >
                    Đăng nhập
                  </a>
                </div>
              </div>
              <div id='enterprise' className='tab-pane fade show active'>
                <form
                  onSubmit={(e) => {
                    handlerFormRegister(e);
                  }}
                >
                  {' '}
                  <div className='form-group'>
                    <label>Tên doanh nghiệp</label>
                    <input
                      type='text'
                      name='name'
                      placeholder=''
                      style={
                        formError.company?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      value={form.company || ''}
                      onChange={(e) => {
                        handlerForm(e.target.value, 'company');
                        checkInputs(
                          e.target.value,
                          ['required'],
                          'company',
                          'Tên doanh nghiệp'
                        );
                      }}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required'],
                          'company',
                          'Tên doanh nghiệp'
                        );
                      }}
                    />
                    {formError.company && formError.company?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.company?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label>Mã số thuế</label>
                    <input
                      type='text'
                      name='tax_code'
                      placeholder=''
                      required
                      style={
                        formError.tax_code?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      value={form.tax_code || ''}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required'],
                          'tax_code',
                          'Mã số thuế'
                        );
                      }}
                      onChange={(e) => {
                        handlerForm(e.target.value, 'tax_code');
                        checkInputs(
                          e.target.value,
                          ['required'],
                          'tax_code',
                          'Mã số thuế'
                        );
                      }}
                    />
                    {formError.tax_code && formError.tax_code?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.tax_code?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label>Email</label>
                    <input
                      type='text'
                      name='email'
                      placeholder=''
                      value={form.email || ''}
                      style={
                        formError.email?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      onChange={(e) => {
                        handlerForm(e.target.value, 'email');
                        checkInputs(
                          e.target.value,
                          ['required', 'email'],
                          'email',
                          'Email'
                        );
                      }}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required', 'email'],
                          'email',
                          'Email'
                        );
                      }}
                    />
                    {formError.email && formError.email?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.email?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label>Số điện thoại</label>
                    <input
                      type='phone_number'
                      name='phone_number'
                      placeholder=''
                      value={form.phone_number || ''}
                      style={
                        formError.phone_number?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      onChange={(e) => {
                        handlerForm(e.target.value, 'phone_number');
                        checkInputs(
                          e.target.value,
                          ['required', 'phone_number'],
                          'phone_number',
                          'Số điện thoại'
                        );
                      }}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required', 'phone_number'],
                          'phone_number',
                          'Số điện thoại'
                        );
                      }}
                    />
                    {formError.phone_number &&
                    formError.phone_number?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.phone_number?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label>Mật khẩu</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        id='password-field2'
                        type='password'
                        name='password'
                        placeholder=''
                        style={
                          formError.password?.isError === 1
                            ? {
                                borderColor: '#ff3333',
                              }
                            : {}
                        }
                        value={form.password || ''}
                        onChange={(e) => {
                          handlerForm(e.target.value, 'password');
                          checkInputs(
                            e.target.value,
                            ['required', 'min:6'],
                            'password',
                            'Mật khẩu'
                          );
                        }}
                        onBlur={(e) => {
                          checkInputs(
                            e.target.value,
                            ['required', 'min:6'],
                            'password',
                            'Mật khẩu'
                          );
                        }}
                      />
                      <span
                        toggle='#password-field2'
                        className='toggle-password'
                      ></span>
                    </div>
                    {formError.password && formError.password?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.password?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <button
                    type='submit'
                    className='btn_submit flex-center'
                    style={
                      !isDisabledBtn
                        ? { background: ' #BBBBBB', color: '#ffffff' }
                        : {}
                    }
                  >
                    Tạo tài khoản
                  </button>
                  <span className='text-danger'>
                    {isSuccess === false
                      ? '*Đăng kí không thành công, vui lòng kiểm tra lại thông tin đăng ký.'
                      : ''}
                  </span>
                </form>
                <div className='login'>
                  Đã có tài khoản{' '}
                  <a
                    data-dismiss='modal'
                    data-toggle='modal'
                    data-target='#modal-login'
                  >
                    Đăng nhập
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalRegister;
